const BLOCKED_SERIES_TITLES = [
  "半泽直树第一季",
  "白熊咖啡厅",
  "我要准时下班",
  "非自然死亡",
  "重启人生",
  "NHK新闻",
  "2025-NEWS EASY",
] as const;

// Lower probability only (do not fully block)
const LOW_PRIORITY_SERIES_TITLES = [
  "新版标准日本语初下",
  "新版标准日本语初上",
] as const;

const normalizeTitle = (value: unknown) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/[\s\u3000\-_—–\/・·.]/g, "")
    .trim();

const BLOCKED_SERIES_NORMALIZED = BLOCKED_SERIES_TITLES.map((item) => normalizeTitle(item));
const LOW_PRIORITY_SERIES_NORMALIZED = LOW_PRIORITY_SERIES_TITLES.map((item) => normalizeTitle(item));

function titleContainsAny(normalizedTitle: string, normalizedKeywords: readonly string[]) {
  if (!normalizedTitle) return false;
  return normalizedKeywords.some((kw) => kw && normalizedTitle.includes(kw));
}

export function isLiveDemoBlockedSeriesTitle(title: unknown): boolean {
  return titleContainsAny(normalizeTitle(title), BLOCKED_SERIES_NORMALIZED);
}

export function getLiveDemoSeriesWeight(title: unknown): number {
  const normalized = normalizeTitle(title);
  if (!normalized) return 1;
  if (titleContainsAny(normalized, BLOCKED_SERIES_NORMALIZED)) return 0;
  if (titleContainsAny(normalized, LOW_PRIORITY_SERIES_NORMALIZED)) return 0.25;
  return 1;
}
